import React from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
export function OfferSection() {
  return <section id="comprar" className="py-24 px-4 sm:px-6 lg:px-8 bg-white relative overflow-hidden" data-id="element-110">
      {/* Decorative blobs */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-[#F0FDF4] rounded-full blur-3xl -z-10 transform translate-x-1/2 -translate-y-1/2" data-id="element-111"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-[#F59E0B]/5 rounded-full blur-3xl -z-10 transform -translate-x-1/2 translate-y-1/2" data-id="element-112"></div>

      <div className="max-w-4xl mx-auto" data-id="element-113">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-[#FDFAF6] rounded-[2.5rem] p-8 md:p-16 text-center shadow-xl border border-[#2D8C4E]/10 relative" data-id="element-114">
          <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 bg-[#F59E0B] text-white px-6 py-2 rounded-full font-bold text-sm flex items-center shadow-md" data-id="element-115">
            <Clock className="w-4 h-4 mr-2" data-id="element-116" />
            Oferta Especial por Tiempo Limitado
          </div>

          <h2 className="text-3xl md:text-4xl font-bold text-[#1A1A1A] mt-4 mb-6" data-id="element-117">
            Comienza Tu Transformación Hoy
          </h2>

          <div className="flex flex-col items-center justify-center mb-8" data-id="element-118">
            <p className="text-gray-500 font-sans text-lg mb-2" data-id="element-119">
              Valor real del programa completo:
            </p>
            <span className="text-3xl text-gray-400 line-through decoration-red-400/50 decoration-2 font-bold mb-2" data-id="element-120">
              $47.00 USD
            </span>
            <div className="flex items-start justify-center" data-id="element-121">
              <span className="text-2xl font-bold text-[#2D8C4E] mt-2 mr-1" data-id="element-122">
                $
              </span>
              <span className="text-7xl font-bold text-[#2D8C4E] tracking-tight" data-id="element-123">
                6.49
              </span>
              <span className="text-xl font-bold text-[#2D8C4E] mt-8 ml-2" data-id="element-124">
                USD
              </span>
            </div>
          </div>

          <p className="text-gray-700 font-sans max-w-2xl mx-auto mb-10 leading-relaxed" data-id="element-125">
            El precio reducido de $6.49 es una promoción temporal. El valor real
            de este programa es mucho mayor. Si cierras esta página ahora,
            podrías perder el acceso a este precio especial.
          </p>

          <p className="text-xl font-serif text-[#1A1A1A] font-medium mb-10 max-w-2xl mx-auto" data-id="element-126">
            Es el momento de recuperar tu energía, reducir la inflamación y
            sentirte en control de tu cuerpo otra vez.
          </p>

          <a href="https://vitalizateahora.com/cart/51892398162151:1" target="_blank" rel="noopener noreferrer" className="inline-flex w-full sm:w-auto items-center justify-center px-8 py-5 text-lg md:text-xl font-bold text-white bg-[#2D8C4E] rounded-full hover:bg-[#24753F] transition-all duration-300 shadow-[0_8px_30px_rgb(45,140,78,0.3)] hover:shadow-[0_8px_30px_rgb(45,140,78,0.5)] hover:-translate-y-1" aria-label="Haz clic aquí y empieza tu transformación hoy" data-id="element-127">
            👉 Haz clic aquí y empieza tu transformación hoy
          </a>

          <div className="mt-6 flex items-center justify-center space-x-4 text-sm text-gray-500 font-sans" data-id="element-128">
            <span data-id="element-129">✓ Pago 100% Seguro</span>
            <span data-id="element-130">✓ Acceso Inmediato</span>
          </div>
        </motion.div>
      </div>
    </section>;
}